export function updateTagsInState(selectedSubscriptionTags, defaultTag, tagFromState, setSelectedSubscriptionTags) {
  const toggledState = !tagFromState.selected;
  const updatedSubscriptionTags = selectedSubscriptionTags.map((item) =>
    item.tag === defaultTag ? { ...item, selected: toggledState } : item
  );

  setSelectedSubscriptionTags(updatedSubscriptionTags);
}

export function getTagFromState(selectedSubscriptionTags, defaultTag) {
  return selectedSubscriptionTags.length ? selectedSubscriptionTags?.find((el) => el.tag === defaultTag) : {};
}
